import { ArrowLeft, LockKeyhole } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { api, readableError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(readableError(error));
    } finally {
      setLoading(false);
    }
  };

  return <main className="admin-login-page" data-testid="admin-login-page"><Link to="/" className="back-home" data-testid="back-to-site-link"><ArrowLeft size={17} /> Zur Website</Link><form className="login-panel" onSubmit={login} data-testid="admin-login-form"><div className="login-mark"><LockKeyhole size={24} /></div><p className="eyebrow">GESCHÜTZTER BEREICH</p><h1>Willkommen zurück.</h1><p>Bitte melden Sie sich an, um Anfragen und Equipment zu verwalten.</p><label>E-Mail<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></label><label>Passwort<input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></label><button className="button button-primary" disabled={loading} data-testid="admin-login-submit-button">{loading ? "Anmelden…" : "Anmelden"}</button></form></main>;
}